import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { reverse } from 'named-urls';
import { useNavigate } from 'react-router-dom';
import CommonTable from '../common/components/CommonTable';
import DealersTableRow from './DealersTableRow';
import CommonLoader from '../common/components/CommonLoader';
import RouterPaths from '../constants/RouterPaths';
import { SET_DEALER_SEARCH_STATE } from './DealersReducer';

const headers = [
  {
    label: 'Company name',
  },
  {
    label: 'Trade name',
  },
  {
    label: 'Email address',
  },
  {
    label: 'Phone number',
  },
  {
    label: 'Status',
  },
  {
    label: 'Avg. purchase per week',
  },
  {
    label: 'Avg. purchase per month',
  },
  {
    label: 'Actions',
    className: 'text-right',
  },
];

function DealersTable({ data, offset, changeOffset, searchParams }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loaderStatus = useSelector((state) => state.dealers.get('loaderStatus'));

  const handleRowClick = (item) => {
    dispatch({
      type: SET_DEALER_SEARCH_STATE,
      payload: {
        dealerId: item.id,
        searchParams,
      },
    });
    navigate(reverse(RouterPaths.DEALER_INFORMATION, { id: item.id }));
  };

  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            rowIdPrefix="dealer-row"
            rowComponent={DealersTableRow}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={headers}
            title="Dealers"
            onRowClick={handleRowClick}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
}

DealersTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default DealersTable;
